import { EInvoiceType } from '@linqpal/models'
import {
  IInvoiceCompanyInfo,
  invoiceStatus,
  IPayloadData,
} from '@linqpal/models/src/dictionaries'
import moment from 'moment'

export function normalizeJwtInvoice(
  invoiceFromPayload: IPayloadData,
  companyInfo: IInvoiceCompanyInfo,
  existingInvoice: any,
) {
  return {
    id: existingInvoice?._id ?? null,
    customerId: existingInvoice?.customer_account_id ?? '',
    supplierInvitationDetails:
      existingInvoice?.supplierInvitationDetails ?? null,
    total_amount: invoiceFromPayload.totalAmount,
    invoice_number: invoiceFromPayload.invoiceNumber,
    invoice_due_date: moment().tz('America/Chicago'),
    company: companyInfo,
    type: EInvoiceType.INVOICE,
    status: invoiceStatus.due,
    connector: {
      integrationId: invoiceFromPayload.connector.integrationId,
      project: invoiceFromPayload.connector.projectDetails,
      customerId: invoiceFromPayload.connector.externalCustomerId,
    },
    lines: invoiceFromPayload.lines.map((line) => ({
      description: line.description,
      unitAmount: line.unitAmount,
      quantity: line.quantity,
      subTotal: line.subTotal,
      taxAmount: line.taxAmount,
      totalAmount: line.totalAmount,
    })),
  }
}
